/*
 * @Description: '报销管理页面;
 * @Author: 贾博宁
 * @Date: 2021 03.16
 *
*/

export default [
    {
        path: 'product7',
        component:resolve => require(['@/views/product7'], resolve),
        name: 'product7',
        meta: {
            nav: '电子档案管理'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/product7.js